module.exports = __webpack_public_path__ + "img/wxkf6.c73ba992.jpg";